import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ApiService} from '../../services/api.service';
import {Alumno} from '../../interfaces/interfaces';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-buscar',
  templateUrl: './buscar.component.html',
  styleUrls: ['./buscar.component.scss'],
})
export class BuscarComponent implements OnInit {
  @ViewChild('inputArea', {read: ElementRef, static: true}) inputArea: ElementRef;

  USUARIOS: Alumno[];
  items: Alumno[] = [];

  constructor(
    private API: ApiService,
    private shared: SharedService,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.API.getAlumnos().subscribe(res => {
      this.USUARIOS = res.sort(this.shared.sortByCompletName);
    });
    setTimeout(() => {
      this.inputArea.nativeElement.setFocus()
    }, 600)
  }

  getItems(ev: any) {
    this.items = [];
    const val = ev.target.value;
    if (val && val.trim() !== '' && val.length > 2) {
      this.items = this.USUARIOS
        .filter(item =>
          this.shared.quitarAcentos(item.nombreCompleto.toLowerCase())
            .indexOf(this.shared.quitarAcentos(val.toLowerCase())) > -1
        )
      return
    }
    this.items = []
  }

}
